<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/147357759
     */
    const props = defineProps<IWidgetProps<LookbookCollageData>>();
    const { cmsComponentProps } = useWidget(props);
</script>
<template>
    <mol-lookbook-collage v-bind="cmsComponentProps" />
</template>
